import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { IoMdClose } from 'react-icons/io';
import { MdNotificationsActive } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { HEADERMENU_PATH } from '../../../routes/RoutesURL';
import { RootState } from '../../../store/rootReducer';
import HSButton from '../../common/Button';
import { isNonAuthenticatedUrl } from '../../login/utils';
import AnnoucementActions from './redux/actions';

const AnnoucementsUI: React.FC = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    const annoucements = useSelector((state: RootState) => state.announcement.annoucement);
    const jwtToken = useSelector((state: RootState) => state.user.jwtToken);

    const [isShowAnnoucement, setShowAnnoucement] = useState(true);
    const [isShowComponent, setShowComponent] = useState(false);

    useEffect(() => {
        if (jwtToken) {
            if (location.pathname.includes(HEADERMENU_PATH.onboarding) || isNonAuthenticatedUrl(location.pathname)) {
                setShowComponent(false);
                return;
            } else {
                setShowComponent(true);
                dispatch(AnnoucementActions.fetchAnnoucementReq());
            }
        } else {
            setShowComponent(false);
        }
    }, [location, jwtToken, dispatch]);

    if (!isShowComponent) {
        return null;
    }

    return (
        <div className="fixed bottom-4 right-4">
            {annoucements && annoucements.length > 0 && (
                <>
                    {!isShowAnnoucement && (
                        <div
                            className="w-12 h-12 rounded-full bg-gray-800 flex justify-center items-center shadow-lg cursor-pointer"
                            onClick={() => setShowAnnoucement(true)}
                        >
                            <MdNotificationsActive size="1.5rem" color="#fff" />
                        </div>
                    )}
                    {isShowAnnoucement && (
                        <div className="rounded-2xl bg-white w-72 shadow-lg pb-3 scrollbarcss md:w-96">
                            <div className="p-4 rounded-t-2xl relative" style={{ backgroundColor: '#16365c' }}>
                                <div className="flex justify-center items-center text-base text-white">
                                    <MdNotificationsActive size="1.2rem" className="mr-2" />
                                    Announcements
                                </div>
                                <IoMdClose
                                    className="text-white cursor-pointer absolute right-4 top-5"
                                    size="1.2rem"
                                    onClick={() => setShowAnnoucement(false)}
                                />
                            </div>
                            <div className="max-h-64 overflow-auto">
                                {annoucements.map((a, index) => (
                                    <div
                                        className={`px-3 py-4 ${index !== annoucements.length - 1 ? 'border-b-2' : ''}`}
                                        key={`${index}_annoucements`}
                                    >
                                        <p className="text-base SourceSansPro-SemiBold text-blue-700">{a.dealName}</p>
                                        <p className="SourceSansPro-SemiBold text-base">{a.title}</p>
                                        <p className="text-base py-2">{a.details}</p>
                                        <p className="text-base SourceSansPro-SemiBold" style={{ color: '#c49a6d' }}>
                                            {moment(a.time).format('MMMM Do YYYY, h:mm:ss a')}
                                        </p>
                                        <div className="flex justify-center items-center p-4 pb-0">
                                            <HSButton
                                                title="View Details"
                                                onClick={() => {
                                                    if (a.url === 'Deal Link') {
                                                        window.open(`/deal/${a.dealUUID}`, '_black');
                                                    } else {
                                                        window.open(a.url, '_black');
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default AnnoucementsUI;
